/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_Orders_Desc6Inputs */

const en_svc_messaging_bots_orders_desc6 = /** @type {(inputs: Svc_Messaging_Bots_Orders_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customers browse, customize and pay without leaving chat. Orders land in your system, confirmed.`)
};

const ar_svc_messaging_bots_orders_desc6 = /** @type {(inputs: Svc_Messaging_Bots_Orders_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يتصفح العملاء ويخصصون ويدفعون دون مغادرة المحادثة. تصل الطلبات مؤكدة إلى نظامك.`)
};

const bn_svc_messaging_bots_orders_desc6 = /** @type {(inputs: Svc_Messaging_Bots_Orders_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কাস্টমাররা চ্যাট না ছেড়েই দেখে, কাস্টমাইজ করে আর পেমেন্ট করে। অর্ডার নিশ্চিত হয়ে আপনার সিস্টেমে আসে।`)
};

const de_svc_messaging_bots_orders_desc6 = /** @type {(inputs: Svc_Messaging_Bots_Orders_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunden stöbern, konfigurieren und zahlen, ohne den Chat zu verlassen. Bestellungen landen bestätigt in Ihrem System.`)
};

const es_svc_messaging_bots_orders_desc6 = /** @type {(inputs: Svc_Messaging_Bots_Orders_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los clientes exploran, personalizan y pagan sin salir del chat. Los pedidos llegan confirmados a su sistema.`)
};

const fr_svc_messaging_bots_orders_desc6 = /** @type {(inputs: Svc_Messaging_Bots_Orders_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les clients parcourent, personnalisent et paient sans quitter le chat. Les commandes arrivent confirmées dans votre système.`)
};

const pt_svc_messaging_bots_orders_desc6 = /** @type {(inputs: Svc_Messaging_Bots_Orders_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os clientes exploram, personalizam e pagam sem sair do chat. Os pedidos chegam confirmados ao seu sistema.`)
};

const zh_svc_messaging_bots_orders_desc6 = /** @type {(inputs: Svc_Messaging_Bots_Orders_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`客户不离开聊天即可浏览、定制和付款。订单确认后直达你的系统。`)
};

const tr_svc_messaging_bots_orders_desc6 = /** @type {(inputs: Svc_Messaging_Bots_Orders_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müşteriler sohbetten çıkmadan gezer, özelleştirir ve öder. Siparişler onaylı şekilde sisteminize düşer.`)
};

const ru_svc_messaging_bots_orders_desc6 = /** @type {(inputs: Svc_Messaging_Bots_Orders_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Клиенты смотрят, настраивают и платят не выходя из чата. Заказы подтверждёнными оказываются в вашей системе.`)
};

const pl_svc_messaging_bots_orders_desc6 = /** @type {(inputs: Svc_Messaging_Bots_Orders_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klienci przeglądają, konfigurują i płacą bez wychodzenia z czatu. Zamówienia lądują potwierdzone w systemie.`)
};

/**
* | output |
* | --- |
* | "Customers browse, customize and pay without leaving chat. Orders land in your system, confirmed." |
*
* @param {Svc_Messaging_Bots_Orders_Desc6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_orders_desc6 = /** @type {((inputs?: Svc_Messaging_Bots_Orders_Desc6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_Orders_Desc6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_orders_desc6(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_orders_desc6(inputs)
	if (locale === "de") return de_svc_messaging_bots_orders_desc6(inputs)
	if (locale === "es") return es_svc_messaging_bots_orders_desc6(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_orders_desc6(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_orders_desc6(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_orders_desc6(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_orders_desc6(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_orders_desc6(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_orders_desc6(inputs)
	return en_svc_messaging_bots_orders_desc6(inputs)
});
export { svc_messaging_bots_orders_desc6 as "svc_messaging-bots_ORDERS_desc" }